// import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  // Cookies.get(TokenKey)
  // console.log('getToken',sessionStorage.getItem(TokenKey))
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token,ischecked) {
  // return Cookies.set(TokenKey, token)
  if(ischecked){
    console.log(ischecked,'token存储在localStorage')
    localStorage.setItem(TokenKey,token)
    sessionStorage.setItem(TokenKey,token)
  }else{
    console.log(ischecked,'token存储在sessionStorage')
    sessionStorage.setItem(TokenKey,token)
  }
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  sessionStorage.removeItem(TokenKey)
  localStorage.removeItem(TokenKey)
}

export function setUser(user){
  sessionStorage.setItem('user',user)
}

export function getUser(){
  // console.log(localStorage.getItem('user'))
  return JSON.parse(sessionStorage.getItem('user'))
}

export function setPRoutes(arr) {
  localStorage.setItem('projectRoutes',arr)
}

export function getPRoutes() {
  return JSON.parse(localStorage.getItem('projectRoutes'))
}
